import React, {Component} from 'react';
import PropTypes from "prop-types";
import translate from "../../services/translation";
import NumberFormat from "react-number-format";

export default class InspirationItem extends Component {

    static propTypes = {
        excursion: PropTypes.object
    };

    truncate = (string, limit) => {
        if (string.length <= limit) {
            return string
        }

        return string.slice(0, limit) + "...";
    }

    render() {
        const {excursion} = this.props;

        return (
            <div className="itineraryExcursionTeaserTile">
                <a href={excursion.detailPageUrl} title={excursion.title} target={"_blank"}>
                    <div className="teaserImageContainer">
                        {excursion.travelarea &&
                            <div className="teaserTravelArea">
                                {excursion.travelarea}
                            </div>
                        }
                        <img alt={excursion.title} src={excursion.teaserImageUrl} />
                    </div>
                    <div className="teaserTextContainer">
                        {excursion.category &&
                            <div className="itineraryExcursionItemCategory">
                                {excursion.category}
                            </div>
                        }
                        {excursion.title &&
                            <div className="itineraryExcursionItemTitle">
                                {excursion.title}
                            </div>
                        }
                        {excursion.description &&
                            <div className="itineraryExcursionItemTeaserText">
                                {this.truncate(excursion.description, 150)}
                            </div>
                        }
                        {excursion.price !== 0 ?
                            <div className="itineraryExcursionPriceInformation">
                                <span className="fromPriceText">{translate('itinerary_item.from')}</span>
                                <span className="fromPrice"><NumberFormat prefix={'Fr. '} value={excursion.price} displayType='text' thousandSeparator={"'"} suffix={'.-'} /></span>
                                <span className="fromPriceInfo">
                                    {excursion.priceLabel ? excursion.priceLabel : translate('itinerary_item.price_per_person')}
                                </span>
                            </div>
                            :
                            <span className="fromPriceInfo request">{translate('itinerary_item.price_on_request')}</span>
                        }
                        {excursion.ltrKey &&
                            <div className="itineraryExcursionItemLtr">
                                {excursion.ltrKey}
                            </div>
                        }
                    </div>
                </a>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Favourites/InspirationItem.js